import { Frame, Navigation } from '@shopify/polaris';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { CarrierControlRoutes } from './features/carrier-control/routes';

const NAV_ITEMS = [
  { label: 'Overview', url: '/admin/carrier-control' },
  { label: 'Consignments', url: '/admin/carrier-control/consignments' },
  { label: 'Fallback rates', url: '/admin/carrier-control/fallback-rates' },
  { label: 'TNT settings', url: '/admin/carrier-control/tnt-settings' },
  { label: 'Tracking log', url: '/admin/carrier-control/tracking-log' },
  { label: 'Webhook log', url: '/admin/carrier-control/webhook-log' },
  { label: 'CarrierService', url: '/admin/carrier-control/carrier-service' },
];

function AdminNavigation(): JSX.Element {
  const { pathname } = useLocation();
  return (
    <Navigation location={pathname}>
      <Navigation.Section
        title="Carrier control"
        items={NAV_ITEMS.map((item) => ({
          label: item.label,
          url: item.url,
          selected:
            item.url === '/admin/carrier-control'
              ? pathname === item.url || pathname === `${item.url}/`
              : pathname.startsWith(item.url),
        }))}
      />
    </Navigation>
  );
}

export function App(): JSX.Element {
  return (
    <Frame navigation={<AdminNavigation />}>
      <Routes>
        <Route path="/" element={<Navigate to="/admin/carrier-control" replace />} />
        <Route path="/admin" element={<Navigate to="/admin/carrier-control" replace />} />
        <Route path="/admin/carrier-control/*" element={<CarrierControlRoutes />} />
      </Routes>
    </Frame>
  );
}
